import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../assets/css/layouts/Navbar.css';
import fallbackLogo from '../../assets/img/login.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const API_BASE_URL = process.env.REACT_APP_API_URL;
const Navbar = ({ toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({ companyName: '', companyLogo: '', description: '' });
  const dropdownRef = useRef();
  const navigate = useNavigate();

  const userEmail = localStorage.getItem('email') || 'Guest';
  const token = localStorage.getItem('token'); // Assuming token is stored here

  const handleLogout = useCallback(() => {
    localStorage.clear();
    navigate('/login');
  }, [navigate]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/settings`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          const settings = response.data[0];
          setCompanyInfo({
            companyName: settings.companyName?.trim() || 'Welcome',
            companyLogo: settings.companyLogo || '',
            description: settings.description || '',
          });
        }
      } catch (err) {
        console.error('Failed to load settings:', err);
      }
    };
    fetchSettings();
  }, []);

  // Periodic user status check - runs every 5 seconds
  useEffect(() => {
    if (!token) return; // no token means no need to check

    const interval = setInterval(async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/users`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Assuming response data is array of users
        const users = res.data;
        const currentUser = users.find(u => u.email === userEmail);

        if (!currentUser) {
          // User not found, logout immediately
          handleLogout();
          return;
        }

        // Check status and deleted flags
        if (currentUser.status !== 'Active' || currentUser.deleted === true) {
          handleLogout();
        }
      } catch (err) {
        console.error('Error checking user status:', err);
        // Optionally logout on error:
        // handleLogout();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [token, userEmail, handleLogout]);

  const logoSrc = companyInfo.companyLogo
    ? `${API_BASE_URL}/uploads/${companyInfo.companyLogo}`
    : fallbackLogo;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg custom-navbar shadow-sm bg-white px-3">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-3">
          <button className="btn me-2" onClick={toggleSidebar}>
            <i className="bi bi-list fs-4"></i>
          </button>
          <img src={logoSrc} alt="Company Logo" className="logo-img" height={40} />
        </div>

        <div className="position-relative" ref={dropdownRef}>
          <i
            className="bi bi-person-circle fs-3 text-dark user-icon"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style={{ cursor: 'pointer' }}
          ></i>

          {dropdownOpen && (
            <div
              className="dropdown-menu dropdown-menu-end show p-2 shadow"
              style={{ position: 'absolute', right: 0, top: '100%', minWidth: '200px' }}
            >
              <div className="px-3 py-2 border-bottom">
                <small className="text-muted">Signed in as</small>
                <br />
                <strong>{userEmail}</strong>
              </div>
              <button className="dropdown-item d-flex align-items-center">
                <i className="bi bi-person me-2"></i> Profile
              </button>
              <button className="dropdown-item d-flex align-items-center" onClick={handleLogout}>
                <i className="bi bi-box-arrow-right me-2"></i> Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
